import { DateTime } from 'luxon';

export function formatDateStringToIso(inputDate?: string | null): string | undefined {
    if (!inputDate) return undefined;
    const formattedDateOfBirth = DateTime.fromISO(inputDate).toISODate({ format: 'extended' });
    if (!formattedDateOfBirth) return undefined;

    return formattedDateOfBirth;
}
